import {
  START_LOADING,
  SET_USER_DETAIL,
  UPDATE_USER_DETAILS,
  SET_USER_TOKEN,
  LOGOUT,
} from "./constant";

export const initStateFeed = {
  isLoading: false,
  currentLocation: "",
  userDetails: null,
  userToken: null,
  isSuperAdmin: false,
};

const authReducer = (state = initStateFeed, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SET_USER_TOKEN:
      return {
        ...state,
        userToken: action.payload,
      };

    case SET_USER_DETAIL:
      return {
        ...state,
        userDetails: action.payload,
        isSuperAdmin: action.payload?.isSuperAdmin || false,
      };

    case UPDATE_USER_DETAILS:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.payload,
        },
      };

    case LOGOUT:
      return {
        ...state,
        userDetails: null,
        userToken: null,
        isSuperAdmin: false,
      };

    default:
      return state;
  }
};

export default authReducer;
